import logo from "./logo.svg";
import "./App.css";

import { Route, Routes } from "react-router-dom";
import Home from "./Screens/Home";
import Code from "./Screens/Code";
import Facilitate from "./Screens/Facilitate";
import Agenda from "./Screens/Agenda";
import About from "./Screens/About";
function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/code" element={<Code />} />
        <Route path="/about" element={<About />} />
        <Route path="/facilitate" element={<Facilitate />} />
        <Route path="/agenda" element={<Agenda />} />
      </Routes>
    </>
  );
}

export default App;
